import { parseNumeric } from '../helpers/number';

export class PayrollBalance {
  accountBalance: number;
  payrollsTotal: number;

  constructor(data: PayrollBalance | DjangoPayrollBalance) {
    if (data instanceof PayrollBalance) {
      bindPayrollBalance(this, data);
    } else {
      bindDjangoPayrollBalance(this, data);
    }
  }
}

///////////////////
// DJANGO SUPPOT //
///////////////////

export interface DjangoPayrollBalance {
  account_balance: number;
  payrolls_total: number;
}

function bindPayrollBalance(PayrollBalance: PayrollBalance, data: PayrollBalance) {
  PayrollBalance.accountBalance = data.accountBalance;
  PayrollBalance.payrollsTotal = data.payrollsTotal;
}

function bindDjangoPayrollBalance(PayrollBalance: PayrollBalance, data: DjangoPayrollBalance) {
  PayrollBalance.accountBalance = parseNumeric(data.account_balance);
  PayrollBalance.payrollsTotal = parseNumeric(data.payrolls_total);
}
